export const FACTORING_HEADER_TITLE_CLASS_NAME = 'factoring-header-title';
export const FACTORING_HEADER_DESCRIPTION_CLASS_NAME = 'factoring-header-description';
export const DOCUMENT_SUMMARY_TITLE_CLASS_NAME = 'document-summary-title';
export const SHOPPING_CART_SUMMARY_TITLE_CLASS_NAME = 'shopping-cart-summary-title';
export const ACCORDION_SUMMARY_TITLE_CLASS_NAME = 'accordion-summary-title';
export const SHOPPING_CART_SUMMARY_TOTAL_TITLE_CLASS_NAME = 'shopping-cart-summary-total-title';
export const SHOPPING_CART_SUMMARY_VALUE_CLASS_NAME = 'shopping-cart-summary-value';
export const SHOPPING_CART_SUMMARY_CHILD_VALUE_CLASS_NAME = 'shopping-cart-summary-child-value';
